import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { TariffService } from 'brain-data/service/tariff/tariff.service';
import { loadTariffs, loadTariffsError, loadTariffsSuccess } from '../actions/tariff.action';

@Injectable()
export class TariffEffects {
  loadTariffs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTariffs),
      switchMap(() =>
        this.tariffService.getAll().pipe(
          map(tariffs => loadTariffsSuccess({ tariffs })),
          catchError((error: Error) => of(loadTariffsError({ error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private tariffService: TariffService,
  ) {}
}
